import { uploadEventLog_File as uploadEventLogDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type UploadCSVProps = {
    csv?: string[];
    filename?: string
}

export const uploadEventLog = ({
    csv,
    filename,
}: UploadCSVProps) => {
    uploadEventLogDiagram(csv, filename);
};
